import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { XWareLogService } from './xware-log.service';
import * as SignatureModels from '../models/signature.models';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SignatureService {
  private api = {
    getSignaturePreview: '/Event/GetDefaultSignature',
  };
  public newId: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public latestsLinksJText: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(
    private http: HttpClient,
    private cw: XWareLogService
  ) {}

  public getSignaturePreview(
    data: Partial<SignatureModels.UserEmailInformation>
  ): Observable<SignatureModels.SignaturesStatusResponse> {
    const url = environment.apiSignaturePreviewServer + this.api.getSignaturePreview;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const userEmailInformation: SignatureModels.UserEmailInformationRequest = {
      BaseURL: data.baseURL ?? null,
      Body: data.body ?? null,
      BodyType: data.bodyType ?? 'html',
      Date: data.date ? new Date(data.date) : new Date(),
      From: data.from ?? '',
      IsReplyEmail: data.isReplyEmail === 'true' || data.isReplyEmail === '1',
      Subject: data.subject ?? '',
      To: data.to ?? [],
      Sender: (data as any).sender ?? data.from ?? '',
      Upn: (data as any).upn ?? data.from ?? '',
      UseUpnForFrom: false,
      DefaultSignatureId: (data as any).defaultSignatureId ?? (data as any).sigid ?? null,
      CheckFF: false,
    };
    const body: SignatureModels.GetDefaultSignatureRequestBody = {
      userEmailInformation,
      selectable: false,
      getAutoDefaultType: true,
    };
    return this.http.post<SignatureModels.SignaturesStatusResponse>(url, body, { headers });
  }
}

